import { combineReducers } from 'redux'

import entries from './entries/reducers'

const faqReducer = combineReducers({
  entries,
})

export default faqReducer
